import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { adminMainUrl } from "../../../Config";
import Cookies from "js-cookie";
import Select from "react-select";

const VoucherProcessingRemittancePosting = ({
  setPostPreData,
  postPreData,
}) => {
  const token = Cookies.get("token");
  const user_id = Cookies.get("flexichain_user_id");
  const [remittanceList, setRemittanceList] = useState([]);
  const [selectedRemittanceId, setSelectedRemittanceId] = useState("");

  useEffect(() => {
    fetchRemittanceList();
  }, []);

  const fetchRemittanceList = async () => {
    try {
      const res = await fetch(
        `${adminMainUrl}/api/account/remittance-clubbing-all`,
        {
          headers: {
            "Content-Type": "application/json",
            "auth-token": token,
            user_id: user_id,
          },
        }
      );
      const data = await res.json();
      if (res.ok) {
        setRemittanceList(data?.data || []);
      } else {
        toast.error(data?.msg || "Failed to fetch remittance list");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error fetching remittance list");
    }
  };

  const remittanceOptions = remittanceList.map((item) => ({
    value: item.id, // or item._id 
    label: item.remittance_id,
    data: item, // store full object 
  }));

  // console.log(remittanceOptions)

  const handleRemittanceChange = (selectedOption) => {
    setSelectedRemittanceId(selectedOption?.value || "");
    if (selectedOption?.data) {
      setPostPreData(selectedOption.data); // populate full UI
    }

  };

  const invoiceAmountBase = Number(postPreData?.invoice_amount || 0); // should come from backend
  const remittanceBase = Number(postPreData?.base_amount || 0);
  const exchangeGainLoss = remittanceBase - invoiceAmountBase; // positive = gain

  const [remittancePosting, setRemittancePosting] = useState({
    posting_date: "",
    bank_account: "",
    posting_narration: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;
  const queryParams = new URLSearchParams(location.search);

  const onValueChange = (e) => {
    const { name, type, value, checked } = e.target;

    setRemittancePosting((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validateForm = () => {
    const errors = [];

    if (!remittancePosting.bank_account?.trim()) {
      errors.push("bank_account is required");
    }

    if (!remittancePosting.posting_date) {
      errors.push("Remittance Date is required");
    }

    if (!remittancePosting.posting_narration) {
      errors.push("posting_narration is required");
    }

    if (errors.length > 0) {
      errors.forEach((err) => toast.error(err));
      return false;
    }

    return true;
  };

  const postRemittanceApi = async () => {
    if (!validateForm()) return;
    // console.log("remittancePosting:", remittancePosting);

    try {
      setIsSubmitting(true);

      const response = await fetch(
        `${adminMainUrl}/api/account/remittance-clubbing-post`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"),
            user_id: Cookies.get("flexichain_user_id"),
          },
          body: JSON.stringify(remittancePosting),
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success(data?.msg || "Post Remittance successfully");
      } else {
        toast.error(data?.msg || "Failed to post remittance voucher");
        console.error("Server error:", data);
      }
    } catch (error) {
      console.error("Network error:", error);
      toast.error("Something went wrong while saving");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <style>
        {`
        .padding-pt-9 {
           padding: 9px;
          }
        `}
      </style>
      <div className="card p-4">
        <h5 className="fw-semibold mb-3">Remittance Details</h5>

        <div className="row g-3">
          {/* Remittance Number */}
          <div className="col-md-4">
            <label className="fw-medium text-muted">Remittance Number</label>
            {/* <div className="px-3 py-2 bg-light rounded-3 mt-1 fw-semibold">
              {postPreData?.remittance_id}
            </div> */}
            <Select
              options={remittanceOptions}
              value={remittanceOptions.find(
                (opt) => opt.value === selectedRemittanceId
              )}
              onChange={handleRemittanceChange}
              placeholder="Select Remittance"
              className="mt-1"
            />
          </div>

          {/* Remittance Date */}
          <div className="col-md-4">
            <label className="fw-medium text-muted">Remittance Date</label>
            <div className="px-3 py-2 bg-light rounded-3 mt-1 fw-semibold">
              {postPreData?.remittance_date}
            </div>
          </div>

          {/* Party Name */}
          <div className="col-md-4">
            <label className="fw-medium text-muted">Party Name</label>
            <div className="px-3 py-2 bg-light rounded-3 mt-1 fw-semibold">
              {postPreData?.party_name}
            </div>
          </div>

          {/* Currency */}
          <div className="col-md-4">
            <label className="fw-medium text-muted">Currency</label>
            <div className="px-3 py-2 bg-light rounded-3 mt-1 fw-semibold">
              {postPreData?.currency_master ? postPreData.currency_master.currency_name ?? "-" : "-"}
            </div>
          </div>

          {/* Remittance Amount (USD) */}
          <div className="col-md-4">
            <label className="fw-medium text-muted">
              Remittance Amount 
            </label>
            <div className="px-3 py-2 bg-light rounded-3 mt-1 fw-semibold">
              $ {postPreData?.net_remittance}
            </div>
          </div>

          {/* Base Amount (INR) */}
          <div className="col-md-4">
            <label className="fw-medium text-muted">Base Amount</label>
            <div className="px-3 py-2 bg-light rounded-3 mt-1 fw-semibold">
              ₹ {postPreData?.base_amount}
            </div>
          </div>

          {/* Invoice Amount (INR) */}
          {/* <div className="col-md-4">
            <label className="fw-medium text-muted">Invoice Amount (INR)</label>
            <div className="px-3 py-2 bg-light rounded-3 mt-1 fw-semibold">
              ₹ {postPreData?.invoice_amount}
            </div>
          </div> */}

          {/* Exchange Variance */}
          {/* <div className="col-md-4">
            <label className="fw-medium text-muted">Exchange Variance</label>
            <div className="px-3 py-2 bg-light rounded-3 mt-1 fw-semibold">
              ₹ {postPreData?.exchange_variance}
              (Gain)
            </div>
          </div> */}

          {/* Status */}
          <div className="col-md-4">
            <label className="fw-medium text-muted">Current Status</label>
            <div className="px-3 py-2 bg-light rounded-3 mt-1 fw-semibold">
              <span className="badge bg-warning text-dark px-3 py-2 rounded-pill">
                {postPreData?.remittance_status}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* remittance posting */}
      <div className="card p-4">
        <h5 className="fw-semibold mb-3">Remittance Posting</h5>

        <div className="row g-3">
          {/* posting_date */}
          <div className="col-md-6 mb-4">
            <label className="form-label fw-medium">Posting Date</label>
            <input
              type="date"
              name="posting_date"
              className="form-control bg-light"
              placeholder="Enter to date"
              onChange={onValueChange}
              value={remittancePosting.posting_date}
            />
          </div>

          {/* bank account */}
          <div className="col-md-6 mb-4">
            <label className="form-label fw-medium">Bank Account</label>
            <select
              name="bank_account"
              className="form-select bg-light padding-pt-9"
              value={remittancePosting.bank_account}
              onChange={onValueChange}
            >
              <option value="">Select Bank</option>
              {/* <option value="bank_account">Bank Account 1</option> */}
            </select>
          </div>

          {/* posting_narration */}
          <div className="col-12 mb-4">
            <label className="form-label fw-medium">Posting Narration</label>
            <input
              type="text"
              name="posting_narration"
              className="form-control bg-light"
              value={remittancePosting.posting_narration}
              onChange={onValueChange}
              placeholder="Remittance Narration"
            />
          </div>
        </div>
      </div>

      {/* exchange gain /loss */}
      {/* <div className="card p-4">
        <h5 className="fw-semibold mb-3">Exchange Gain/Loss Analysis</h5>

        <div className="row g-3 mb-3">
          <div className="col-md-6">
            <label className="fw-medium text-muted">
              Invoice Exchange Rate
            </label>
            <div className="px-3 py-2 bg-light rounded-3 mt-1 fw-semibold">
              83.1000
            </div>
          </div>

          <div className="col-md-6">
            <label className="fw-medium text-muted">
              Remittance Exchange Rate
            </label>
            <div className="px-3 py-2 bg-light rounded-3 mt-1 fw-semibold">
              83.2500
            </div>
          </div>
        </div>

        <div className="p-3 bg-success bg-opacity-10 rounded-3 border border-success">
          <div className="d-flex justify-content-between">
            <span className="fw-semibold text-muted">Exchange Gain/Loss</span>
            <span className="fw-bold text-success fs-5">₹ 5,350.00</span>
          </div>
          <small className="text-muted">Favorable rate movement</small>
        </div>

        <ul className="mt-3 small text-muted">
          <li>Invoice Amount: USD 35,800 × 83.1000 = ₹ 29,75,000.00</li>
          <li>Remittance Amount: USD 35,800 × 83.2500 = ₹ 29,80,350.00</li>
          <li>Exchange Gain: ₹ 5,350.00</li>
        </ul>
      </div> */}

      {/* Journal Entries Preview */}
      <div className="card p-4">
        {/* <h5 className="fw-semibold mb-3">Journal Entries Preview</h5> */}

        {/* <div className="table-responsive">
          <table className="table table-bordered">
            <thead className="table-light">
              <tr>
                <th>Account</th>
                <th>Debit</th>
                <th>Credit</th>
                <th>Narration</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td className="fw-medium">HDFC Bank - USD Account</td>
                <td>₹ 29,80,350.00</td>
                <td>-</td>
                <td>Remittance received • REM-2025-001</td>
              </tr>

              <tr>
                <td className="fw-medium">
                  Global Shipping LLC - Customer Account
                </td>
                <td>-</td>
                <td>₹ 29,75,000.00</td>
                <td>Invoice adjustment against remittance</td>
              </tr>

              <tr>
                <td className="fw-medium">Foreign Exchange Gain/Loss</td>
                <td>-</td>
                <td>₹ 5,350.00</td>
                <td>Exchange rate variance on remittance</td>
              </tr>

              <tr className="table-light fw-semibold">
                <td>Total</td>
                <td>₹ 29,80,350.00</td>
                <td>₹ 29,80,350.00</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div> */}

        {/* <div className="alert alert-info mt-3 py-2">
          <i className="bi bi-check-circle-fill me-2"></i>
          Journal entries are balanced. Total Debits equal Total Credits.
        </div> */}

        <div className="d-flex gap-2 flex-wrap">
          <button
            onClick={() => postRemittanceApi()}
            className="btn btn-primary px-4"
          >
            <i className="fa-solid fa-paper-plane me-1"></i> Post Remittance
          </button>

          <button className="btn-light border px-4">
            <i className="fa-solid fa-xmark me-1"></i> Cancel
          </button>
        </div>
      </div>
    </>
  );
};

export default VoucherProcessingRemittancePosting;
